import React from "react";
import useSeo from "../hooks/useSeo";
import { Link } from "react-router-dom";
import { ShieldCheck, UserCheck, FileCheck2 } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useJobModal } from "../context/JobModalContext";
import { STEPS } from "../mock";

export default function HowItWorks() {
  const { openJobModal } = useJobModal();
  useSeo("How It Works — Hire Trusted Caregivers | SimplySitter", "See how SimplySitter helps families post a job, review vetted caregivers and hire nannies, babysitters and housekeepers with confidence.");

  return (
    <div>
      <Header />
      <section className="hero-gradient">
        <div className="max-w-4xl mx-auto px-5 pt-16 pb-16 text-center">
          <h1 className="font-display text-[2.6rem] leading-[1.05] sm:text-6xl text-[#1f1a1b]">How SimplySitter Works</h1>
          <p className="mt-5 text-[18px] leading-relaxed text-[#5a5254] max-w-2xl mx-auto">
            Post your job for free and connect with experienced, interviewed and background-checked candidates across the United States.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-5 py-16 space-y-4">
          {STEPS.map((s) => (
            <div key={s.n} className="flex items-start gap-5 rounded-2xl border border-black/[0.07] bg-white p-6">
              <div className="w-12 h-12 shrink-0 rounded-full bg-[#17161d] text-white font-display text-xl flex items-center justify-center">{s.n}</div>
              <div><h3 className="font-display text-xl text-[#1f1a1b]">{s.title}</h3><p className="text-[15px] text-[#5a5254] mt-1 leading-relaxed">{s.text}</p></div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#fdfaf7]">
        <div className="max-w-7xl mx-auto px-5 py-16">
          <h2 className="font-display text-3xl sm:text-4xl text-[#1f1a1b] text-center">100% vetted care</h2>
          <div className="grid md:grid-cols-3 gap-5 mt-10">
            {[[ShieldCheck, "Verified & Trusted", "Every candidate verifies their identity before joining."], [UserCheck, "Interviewed", "We personally interview applicants before approving profiles."], [FileCheck2, "Background Checked", "Background and reference checks help families hire with confidence."]].map(([Icon, t, d]) => (
              <div key={t} className="rounded-2xl border border-black/[0.07] bg-white p-7">
                <div className="w-12 h-12 rounded-xl bg-[#f7e4e6] flex items-center justify-center"><Icon className="w-6 h-6 text-[#7c2233]" strokeWidth={1.7} /></div>
                <h3 className="font-display text-xl text-[#1f1a1b] mt-4">{t}</h3>
                <p className="text-[15px] text-[#5a5254] mt-2">{d}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-12 flex flex-wrap justify-center gap-3">
            <button onClick={() => openJobModal({})} className="rounded-xl bg-[#7c2233] hover:bg-[#661b29] text-white font-medium px-7 py-3.5 transition-colors">Post a job free</button>
            <Link to="/for-caregivers" className="rounded-xl border border-[#7c2233]/30 text-[#7c2233] font-medium px-7 py-3.5 hover:bg-[#faf1f2] transition-colors">I'm a caregiver</Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
